import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';

import {Button, Card, Checkbox, DatePicker, Form, Input, notification, Select} from 'antd';

import {cancelPurchaseOrder, getPurchaseOrders} from './actions';
import InputContact from "../common/InputContact";
import {getDescriptionFromError} from "../utils/errors";
import {formItemLayout} from "../utils/style";

const FormItem = Form.Item;
const TextArea = Input.TextArea;
const Option = Select.Option;
const ButtonGroup = Button.Group;

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class CancelPurchaseOrderForm extends Component {
  componentDidMount() {
    this._load();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.dispensaryId !== this.props.dispensaryId) {
      this._load();
    }
  }

  _load = () => {
    const {dispensaryId, getPurchaseOrders} = this.props;
    if (dispensaryId) {
      getPurchaseOrders({dispensaryId, status: ['Draft', 'Sent', 'Ordered']});
    }
  };

  goBack = () => {
    this.props.history.goBack();
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields(async(err, values) => {
      if (err) return;
      try {
        await this.props.cancelPurchaseOrder(values);
        this.goBack();
      } catch (err) {
        notification.error({
          message: 'Failed',
          description: getDescriptionFromError(err)
        });
      }
    });
  };

  render() {
    const {form: {getFieldDecorator, getFieldsError, getFieldValue}, loading, purchaseOrders} = this.props;
    const purchaseId = getFieldValue('purchaseId');
    const purchaseOrder = purchaseOrders.find(({purchaseId: pid}) => (pid === purchaseId)) || {};
    const showUnconfirm = !!(purchaseOrder && purchaseOrder.confirmedDate);
    return (
      <Card title="Cancel Purchase Order">
        <Form onSubmit={this.handleSubmit}>
          <FormItem
            {...formItemLayout}
            label="Purchase Id"
          >
            {getFieldDecorator('purchaseId', {
              rules: [
                {required: true, message: 'Please input your Purchase Id'},
              ]
            })(
              <Select>
                {purchaseOrders.map(({purchaseId, supplierName, status, modifiedAt}) =>
                  <Option key={purchaseId} value={purchaseId}>{`${supplierName} - ${status} (${modifiedAt})`}</Option>
                )}
              </Select>
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Reason"
          >
            {getFieldDecorator('reason', {
              rules: [
                {required: true, message: 'Please input your Reason'},
              ]
            })(
              <TextArea/>
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Cancelled Date"
          >
            {getFieldDecorator('cancelledDate', {
              initialValue: moment(),
              rules: [
                {required: true, message: 'Please input your Cancelled Date'},
              ]
            })(
              <DatePicker/>
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Cancelled By"
          >
            {getFieldDecorator('cancelledBy', {
              initialValue: null,
            })(
              <InputContact key={`cancel-${purchaseId}`}/>
            )}
          </FormItem>
          {showUnconfirm &&
          <FormItem
            {...formItemLayout}
            label="Unconfirm"
          >
            {getFieldDecorator('unconfirm', {initialValue: true})(
              <Checkbox defaultChecked disabled/>
            )}
          </FormItem>
          }
          <FormItem>
            <ButtonGroup>
              <Button
                type="primary"
                htmlType="submit"
                disabled={loading || hasErrors(getFieldsError())}
              >
                Cancel Purchase Order
              </Button>
              <Button
                htmlType="button"
                onClick={this.goBack}
              >
                Cancel
              </Button>
            </ButtonGroup>
          </FormItem>
        </Form>
      </Card>
    );
  }
}

CancelPurchaseOrderForm.propTypes = {
  form: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  dispensaryId: PropTypes.string,
  loading: PropTypes.bool.isRequired,
  cancelPurchaseOrder: PropTypes.func.isRequired,
  getPurchaseOrders: PropTypes.func.isRequired,
  purchaseOrders: PropTypes.array.isRequired,
};

const CancelPurchaseOrderPage = Form.create()(CancelPurchaseOrderForm);

const mapStateToProps = state => ({
  dispensaryId: state.dispensary.selectedDispensaryId,
  loading: state.purchaseOrder.purchaseOrdersLoading || state.purchaseOrder.cancelPurchaseOrderLoading,
  purchaseOrders: state.purchaseOrder.purchaseOrders,
});

const mapDispatchToProps = dispatch => ({
  cancelPurchaseOrder: payload => (dispatch(cancelPurchaseOrder(payload))),
  getPurchaseOrders: payload => (dispatch(getPurchaseOrders(payload))),
});

export default connect(mapStateToProps, mapDispatchToProps)(CancelPurchaseOrderPage);


// WEBPACK FOOTER //
// ./src/PurchaseOrder/CancelPurchaseOrderPage.js